import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f4c789e&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=0f4c789e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c789e",
  null
  
)

export default component.exports